export enum DrawerTypes {
  ADD_PROPERTY,
  EDIT_BMD,
  MANAGE_DATA_TYPE,
  BMD_COUNT,
}

export const ALL_CATEGORY = { id: 0, name: "All", bmdGroups: [], key: 0 };
